import { motion, AnimatePresence } from "framer-motion";
import { useEffect } from "react";

export default function ReceiptModal({ url, onClose }) {
  useEffect(() => {
    function onKey(e) { if (e.key === "Escape") onClose(); }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const isImage = url && /\.(png|jpe?g|webp|gif)(\?.*)?$/i.test(url);

  return (
    <AnimatePresence>
      {url && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.85, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.85, opacity: 0 }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            className="bg-navy-900 border border-navy-700 rounded-2xl overflow-hidden max-w-2xl w-full max-h-[90vh] flex flex-col shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-navy-700 flex-shrink-0">
              <div>
                <h3 className="font-semibold text-slate-100">Podgląd paragonu</h3>
                <p className="text-xs text-slate-500 truncate max-w-xs mt-0.5">{url}</p>
              </div>
              <div className="flex items-center gap-2">
                <a
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-ghost text-xs py-2 px-3"
                >
                  Otwórz ↗
                </a>
                <button
                  onClick={onClose}
                  className="w-8 h-8 rounded-lg border border-navy-700 text-slate-400 hover:text-slate-200 hover:border-navy-600 transition-colors flex items-center justify-center"
                >
                  ✕
                </button>
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-auto flex items-center justify-center p-4 min-h-[300px]">
              {isImage ? (
                <img
                  src={url}
                  alt="Paragon"
                  className="max-w-full max-h-[70vh] object-contain rounded-lg"
                />
              ) : (
                <div className="text-center space-y-4">
                  <div className="text-4xl">📄</div>
                  <p className="text-slate-400 text-sm">
                    Ten plik nie może być wyświetlony bezpośrednio.<br />
                    Kliknij "Otwórz" aby zobaczyć paragon.
                  </p>
                  <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-primary inline-block"
                  >
                    Otwórz paragon ↗
                  </a>
                </div>
              )}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
